<template>
  <div class="app-main-content">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%;height: 100%" @tab-click="handleTabClick">
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_OcrTemplateConfig')" name="ocrTemplateConfig" style="width:100%;height: 100%">
          <ocr-template-config ref="ocrTemplateConfig" :tab-title="$t('CargoMsg.Cargo_OcrTemplateConfig')" />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_PlatformEnterpriseInterfaceConfiguration')" name="enterpriseInterfaceConfig" style="width:100%;height: 100%">
          <enterprise-interface-config ref="enterpriseInterfaceConfig" :tab-title="$t('CargoMsg.Cargo_PlatformEnterpriseInterfaceConfiguration')" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import ocrTemplateConfig from '@/views/cargo/v0/SystemMaintenance/components/ocr/ocrTemplateConfig'
import enterpriseInterfaceConfig from '@/views/cargo/v0/SystemMaintenance/components/ocr/enterpriseInterfaceConfig'

export default {
  name: 'OcrConfig',
  components: {
    ocrTemplateConfig,
    enterpriseInterfaceConfig
  },
  data() {
    return {
      loading: true,
      useUserPort: false,
      activeTabName: 'ocrTemplateConfig'
    }
  },
  watch: {
    $route: {
      handler: function(route) {
      },
      immediate: true
    }
  },
  mounted() {
  },
  async created() {
  },
  methods: {
    handleTabClick() {
    }
  }
}
</script>
